import { clone } from "lodash";
import { DateTime } from "luxon";

export default {
    data() {
        return {
            lastUpdatedDuration: null,
            lastUpdatedInterval: null,
            lastUpdatedTimeoutSecond: null,
            lastUpdatedTimeoutMinute: null,
            lastUpdatedDurationText: ""
        };
    },
    beforeDestroy() {
        if (this.lastUpdatedInterval) {
            clearInterval(this.lastUpdatedInterval);
            clearTimeout(this.lastUpdatedTimeoutSecond);
            clearTimeout(this.lastUpdatedTimeoutMinute);
        }
    },
    watch: {
        lastUpdatedDuration(value) {
            let text = "";

            if (value) {
                const { seconds, minutes } = value;

                if ((seconds && seconds < 2) || seconds === 0) {
                    text = "a second";
                } else if (seconds) {
                    text = `${Math.trunc(seconds)} seconds`;
                } else if (minutes && minutes < 2) {
                    text = "a minute";
                } else if (minutes < 60) {
                    text = `${Math.trunc(minutes)} minutes`;
                } else if (minutes > 60) {
                    text = "";
                }
            }

            this.lastUpdatedDurationText = text;
        }
    },
    methods: {
        getBusinessSettings() {
            let self = this;
            // -- https://stackoverflow.com/a/22969338
            let ntp = function (t0, t1, t2, t3) {
                return {
                    roundtripdelay: t3 - t0 - (t2 - t1),
                    offset: (t1 - t0 + (t2 - t3)) / 2
                };
            };
            let t0 = new Date().valueOf();
            return this.$http
                .get(process.env.BARRACUDA + "account/setting")
                .then(response => {
                    self.setting = response.data.response.resource;
                    self.$root.setting = clone(this.setting);

                    let t1 = self.$root.setting.serverTime,
                        t2 = self.$root.setting.serverTime,
                        t3 = new Date().valueOf();

                    self.$root.setting.serverTime = ntp(t0, t1, t2, t3);

                    this.$http
                        .get(
                            process.env.BARRACUDA +
                                "account/setting/currency-symbol"
                        )
                        .then(response => {
                            self.$root.setting.currency_symbol =
                                response.data.response.resource;
                            this.$store.commit(
                                "setCurrency",
                                response.data.response.resource
                            );
                        });
                });
        },
        resetIntervalAndTimeout() {
            if (this.lastUpdatedInterval) {
                clearInterval(this.lastUpdatedInterval);
                clearTimeout(this.lastUpdatedTimeoutSecond);
                clearTimeout(this.lastUpdatedTimeoutMinute);

                this.lastUpdatedInterval = null;
                this.lastUpdatedTimeoutSecond = null;
                this.lastUpdatedTimeoutMinute = null;
            }
        },
        setIntervalAndTimeoutUpdatedDuration(updatedAt) {
            const UPDATED_DURATION_LAST = 3600000;

            this.resetIntervalAndTimeout();

            // NOTE: updateAt value must be in timestamp format
            let updatedDate = updatedAt
                ? DateTime.fromSeconds(updatedAt)
                : this._now();

            // NOTE: Get duration in second
            const getDurationInSecond = () =>
                this._now().diff(updatedDate, ["seconds"]).toObject();

            // NOTE: Get duration in minute
            const getDurationInMinute = () =>
                this._now().diff(updatedDate, ["minutes"]).toObject();

            this.lastUpdatedDuration = getDurationInSecond();

            // NOTE: if the difference in seconds is more than 60 seconds, set interval by minutes
            if (this.lastUpdatedDuration.seconds > 60) {
                this.lastUpdatedDuration = getDurationInMinute();

                this.lastUpdatedInterval = setInterval(() => {
                    this.lastUpdatedDuration = getDurationInMinute();
                }, 60000);
            } else {
                // NOTE: Set interval for first 1 minute so that we have increment 10 seconds
                this.lastUpdatedInterval = setInterval(() => {
                    this.lastUpdatedDuration = getDurationInSecond();
                }, 10000);

                // NOTE: Remove prev interval and add new interval where it has 1 minute increment
                this.lastUpdatedTimeoutSecond = setTimeout(() => {
                    clearInterval(this.lastUpdatedInterval);
                    this.lastUpdatedDuration = getDurationInMinute();

                    this.lastUpdatedInterval = setInterval(() => {
                        this.lastUpdatedDuration = getDurationInMinute();
                    }, 60000);
                }, 60000);
            }

            // NOTE: Remove last interval after UPDATED_DURATION_LAST milliseconds
            this.lastUpdatedTimeoutMinute = setTimeout(() => {
                clearInterval(this.lastUpdatedInterval);
                this.lastUpdatedDuration = null;
                this.lastUpdatedInterval = null;
                this.lastUpdatedDurationText = "";
            }, UPDATED_DURATION_LAST);
        },
    }
};
